/** Панель «Сьогодні» (features/today). */
export const today = {
  todayTitle: 'Сьогодні',
  todayCollapse: 'Згорнути панель «Сьогодні»',
  todayAllTasks: 'Усі задачі',
  overdue: 'Прострочено',
  scheduled: 'На сьогодні',
  waiting: 'Чекають першої реакції',
  done: 'Виконано',
  // «Дзвінки без результату» (Г2-W1; calls.md, розд. 4): мої дзвінки за 7 днів без результату.
  noOutcome: 'Дзвінки без результату',
  noOutcomeOpen: (who: string) => `Записати результат: ${who}`,
  noOutcomeUnknown: 'Без запису клієнта',
  noOutcomeFailed: 'Дзвінки без результату не завантажились',
  completeTask: 'Виконати',
  completedTask: 'Виконано',
  completeWithOutcome: 'Виконати з результатом…',
  moreTaskActions: 'Ще дії',
  snooze: 'Перенести',
  snoozeTomorrow: 'Завтра, 10:00',
  snoozeIn3: 'Через 3 дні',
  snoozeNextWeek: 'Наступного тижня',
  dueInHour: 'Через годину',
  dueTomorrow: 'Завтра',
  dueNextMonday: 'Наступного понеділка',
  dueNoWorkingTime: 'Робочого часу немає — дати за календарем',
  allDay: 'Увесь день',
  personalTask: 'Особиста задача',
  taskDone: 'Задачу виконано',
  taskSnoozed: 'Задачу перенесено',
  emptyTodayTitle: 'На сьогодні задач немає',
  errorTodayTitle: 'Задачі не завантажились',
  errorTodayText: 'Решта екрана працює. Спробуйте ще раз.',
  errorTodayCode: 'TODAY-503',
  hintMove: 'рух',
  hintDone: 'виконано',
  hintSnooze: 'перенести',
  hintCall: 'подзвонити',
  hintOpen: 'відкрити',
  category: { task: 'Задача', call: 'Дзвінок', meeting: 'Зустріч', email: 'Лист' },
  /** Тривалість у робочих хвилинах: «18 хв», «1 год», «1 год 58 хв». */
  workMinutes: (m: number) => {
    const h = Math.floor(m / 60);
    const rest = m % 60;
    if (h === 0) return `${rest} хв`;
    return rest === 0 ? `${h} год` : `${h} год ${rest} хв`;
  },
  slaBreachedBy: (d: string) => `Прострочено на ${d}`,
  slaBreached: 'Прострочено',
  slaWarningLeft: (d: string) => `Під загрозою · ще ${d}`,
  slaWarning: 'Під загрозою',
  slaLeft: (d: string) => `ще ${d}`,
  /** Доступна назва лічильника «Задачі N»: число словом і прострочені окремо (WCAG 1.4.1). */
  tasksCount: (n: string, overdue: number) =>
    overdue > 0 ? `Задач: ${n}, прострочено: ${overdue}` : `Задач: ${n}`,
} as const;
